<template>
  <div>
    <template v-if="animation === 'right'">
      <template v-if="counter === 0">
        <v-icon v-bind:style="styleObject" :color="color" v-for="icon in totalIcons" v-bind:key="icon">
          mdi-ray-start
        </v-icon>
      </template>
      <template v-else-if="counter === 1">
        <v-icon v-bind:style="styleObject" :color="color" v-for="icon in totalIcons" v-bind:key="icon">
          mdi-ray-vertex
        </v-icon>
      </template>
      <template v-else-if="counter === 2">
        <v-icon v-bind:style="styleObject" :color="color" v-for="icon in totalIcons" v-bind:key="icon">
          mdi-ray-end
        </v-icon>
      </template>
      <!--       <v-icon v-bind:style="styleObject" :color="color">
        mdi-ray-start-arrow
      </v-icon> -->
    </template>
    <template v-else-if="animation === 'left'">
      <!--       <v-icon v-bind:style="styleObject" :color="color">
        mdi-ray-end-arrow
      </v-icon> -->
      <template v-if="counter === 0">
        <v-icon v-bind:style="styleObject" :color="color" v-for="icon in totalIcons" v-bind:key="icon">
          mdi-ray-end
        </v-icon>
      </template>
      <template v-else-if="counter === 1">
        <v-icon v-bind:style="styleObject" :color="color" v-for="icon in totalIcons" v-bind:key="icon">
          mdi-ray-vertex
        </v-icon>
      </template>
      <template v-else-if="counter === 2">
        <v-icon v-bind:style="styleObject" :color="color" v-for="icon in totalIcons" v-bind:key="icon">
          mdi-ray-start
        </v-icon>
      </template>
    </template>
    <template v-else-if="animation === 'up'">
      <!--       <v-row justify="center" dense>
        <v-icon v-bind:style="styleObject" :color="color" class="mdi-rotate-90">
          mdi-ray-end-arrow
        </v-icon>
      </v-row> -->
      <v-row justify="center" dense v-for="icon in totalIcons" v-bind:key="icon">
        <template v-if="counter === 0">
          <v-icon v-bind:style="styleObject" :color="color" class="mdi-rotate-90">
            mdi-ray-end
          </v-icon>
        </template>
        <template v-else-if="counter === 1">
          <v-icon v-bind:style="styleObject" :color="color" class="mdi-rotate-90">
            mdi-ray-vertex
          </v-icon>
        </template>
        <template v-else-if="counter === 2">
          <v-icon v-bind:style="styleObject" :color="color" class="mdi-rotate-90">
            mdi-ray-start
          </v-icon>
        </template>
      </v-row>
    </template>
    <template v-else-if="animation === 'down'">
      <v-row justify="center" dense v-for="icon in totalIcons" v-bind:key="icon">
        <template v-if="counter === 0">
          <v-icon v-bind:style="styleObject" :color="color" class="mdi-rotate-270">
            mdi-ray-end
          </v-icon>
        </template>
        <template v-else-if="counter === 1">
          <v-icon v-bind:style="styleObject" :color="color" class="mdi-rotate-270">
            mdi-ray-vertex
          </v-icon>
        </template>
        <template v-else-if="counter === 2">
          <v-icon v-bind:style="styleObject" :color="color" class="mdi-rotate-270">
            mdi-ray-start
          </v-icon>
        </template>
      </v-row>
      <!--       <v-row justify="center" dense>
        <v-icon v-bind:style="styleObject" :color="color" class="mdi-rotate-270">
          mdi-ray-end-arrow
        </v-icon>
      </v-row> -->
    </template>
  </div>
</template>

<script>
export default {
  name: "EnergyFlow",
  props: {
    animation: {
      type: String,
      default: "right",
      require: false,
    },
    size: {
      type: Number,
      default: 38,
      required: true,
    },
    totalIcons: {
      type: Number,
      default: 1,
      required: false,
    },
    color: {
      type: String,
      default: "grey",
      required: false,
    },
    power: {
      type: Number,
      default: 0,
      required: false,
    },
    powerMax: {
      type: Number,
      default: 3.68,
      required: false,
    },
  },
  data() {
    return {
      timer: null,
      timer2: null,

      styleObject: {
        fontSize: this.size + "px",
      },

      counter: 0,
      counterInner: 0,
      counterMax: 3,

      mobile: false,

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.getBreakpoints();

    this.poolAnimation();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    poolAnimation() {
      this.timer = setInterval(() => {
        this.animateEnergyFlow();
      }, 18);

      this.timer2 = setInterval(() => {
        this.styleObject.fontSize = this.size + "px";
      }, 500);
    },
    animateEnergyFlow() {
      let ratio = this.power / this.powerMax;

      if (ratio < 0.2) {
        ratio = 0.2;
      } else if (ratio > 1) {
        ratio = 1;
      }

      this.counterInner += ratio * 25;

      if (this.counterInner >= 100) {
        this.counterInner = 0;

        if (this.power != 0) {
          this.counter++;
          if (this.counter >= this.counterMax) {
            this.counter = 0;
          }
        }
      }
    },
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
  },
  beforeDestroy() {
    if (this.timer != null) {
      clearInterval(this.timer);
    }

    if (this.timer2 != null) {
      clearInterval(this.timer2);
    }

    window.removeEventListener("resize", this.onResize);
  },
  destroyed() {},
};
</script>

<style scoped></style>
